import React from "react";
import {
  Form,
  Row,
  Col,
  Input,
  Label,
  FormGroup,
  Card,
  Button,
  CardBody,
  Container,
  FormText,
  Progress,
} from "reactstrap";
import NotificationSystem from "react-notification-system";
import { connect } from "react-redux";
import { alertActions, commonActions, modalActions } from "../../_actions";
import { alertConstants, appConstants } from "../../_constants";
import { apiActions } from "../../_actions/api.actions";
import { commonService } from "../../_services";

import DatePicker from "react-datepicker";
import moment from "moment";

import "react-datepicker/dist/react-datepicker.css";

//Page Utilities
import PageLoading from "../utils/page.loading";
import PageError from "../utils/page.error";
import PageEmptyContent from "../utils/page.empty-content";

import SelectListComponent from "../utils/selectList";

import { appHelpers, store } from "../../_helpers";
import IATATimeline from "./timeline";

//Icons
import IconRefresh from "react-icons/lib/md/refresh";
import ReportIcon from "react-icons/lib/md/landscape";

import ToolTipItem from "../utils/tooltip";

const ViewContent = ({ children }) => (
  <div className="view-content view-components">{children}</div>
);

class IataViewContent extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      modal: false,
      modalClass: "",
      //page error
      contentError: false, //Errors that affect content on the page
      componentError: false, //Errors generated within the component
      componentErrorMessages: [], //Errors generated within the component form
      error: false, //Error state mutable via Redux
      success: false, //Success message mutable via Redux

      //    Notification
      notification: {
        // title: 'Default Title',
        message: "Default Message",
        level: "success",
        position: "tr",
        dismissible: true,
      },
      airlines: [],
      airports: [],
      iataReports: [],
      categories: [
        {
          Id: 1,
          Name: "Domestic",
        },
        {
          Id: 2,
          Name: "International",
        },
      ],
      categoriesLocal: [
        {
          Id: 1,
          Name: "Domestic",
        },
      ],
      //IATA Form Filter
      selectedCategory: 1,
      sourceAirportId: -1,
      destinationAirportId: -1,
      startDate: new Date(),
      startDate2: new Date(),
      endDate: new Date(),
      AirlineCode: "",
      AirlineId: "",
      AirlineName: "",
      notifyEmail: "",
      activeUser: appHelpers.getActiveUser(),
      pendingReportIntervalId: false,
      defaultAllAirport: {
        Id: -1,
        Name: "All Airport",
      },
      activeSourceAirport: false,
      activeDestinationAirport: false,
    };

    this._notificationSystem = null;
    this._lastNotificationAdded = null;
    this.fetchReports = this.fetchReports.bind(this);
  }

  componentDidMount() {
    this._notificationSystem = this.refs.notificationSystem;
    const reduxState = store.getState();
    let { airlinesCarriers, desAirports } = reduxState;
    if (airlinesCarriers) {
      this.setState({ airlines: airlinesCarriers.Results });
    } else {
      this.fetchAirlines();
    }
    // Fetch  Airports
    if (desAirports) {
      const targetAirports = [...desAirports.Results]; //deep cloning to avoid changing the original list of airports
      targetAirports.unshift(this.state.defaultAllAirport);
      this.setState({
        airports: targetAirports,
      });
    } else {
      this.fetchAirports();
    }

    this.fetchReports(true);

    this._notificationSystem = this.refs.notificationSystem;
  }

  componentWillReceiveProps = function (nextProps) {
    const { alert } = nextProps;
    const { modal } = nextProps;

    if (alert) {
      if (alert.type === alertConstants.SUCCESS) {
        // this.setState({error: false, success: alert.message})
        this.setState({ error: false, success: "Operation successful" });
        this.resetForm();
      } else if (alert.type === alertConstants.CLEAR) {
        this.setState({ success: false, error: false });
      } else {
        this.setState({ success: false, error: alert.message });
      }
    }
    if (modal) {
      if (modal.type === appConstants.OPEN_MODAL) {
        this.setState({
          modal: true,
          modalClass: modal.modalClass,
        });
      } else if (modal.type === appConstants.CLOSE_MODAL) {
        this.setState({
          modal: false,
          modalClass: modal.modalClass,
        });
        this.resetForm();
      }
    }
  };

  notify = (message, level) => {
    let notification = this.state.notification;
    notification["message"] = message;
    notification["level"] = level;
    notification.onRemove = this.onRemove;
    this._lastNotificationAdded =
      this._notificationSystem.addNotification(notification);
  };

  onRemove = (notification) => {
    if (
      this._lastNotificationAdded &&
      notification.uid === this._lastNotificationAdded.uid
    ) {
      this._lastNotificationAdded = null;
    }
  };

  toggle = (e, modalClass) => {
    if (this.state.modal) {
      this.resetForm();
      this.props.dispatch(modalActions.close({ modalClass: modalClass }));
    } else {
      this.props.dispatch(modalActions.open({ modalClass: modalClass }));
    }
  };

  fetchAirlines = () => {
    this.setState({ contentError: false });
    const { dispatch } = this.props;

    dispatch(commonActions.getAirlinesCarriers())
      .then(() => {
        let { airlinesCarriers } = this.props;
        this.setState({ airlines: airlinesCarriers.Results });
      })
      .catch((error) => {
        let errorMessage = appHelpers.interpretErrorResponse(error);
        this.notify(errorMessage, appConstants.NOTIFY_ERROR);
        this.setState({ contentError: errorMessage });
      });
  };

  fetchAirports = () => {
    this.setState({ contentError: false });
    const { dispatch } = this.props;

    dispatch(commonActions.getDesAirports())
      .then(() => {
        const { desAirports } = this.props;
        const targetAirports = [...desAirports.Results]; //deep cloning to avoid changing the original list of airports
        targetAirports.unshift(this.state.defaultAllAirport);
        this.setState({ airports: targetAirports });
      })
      .catch((error) => {
        let errorMessage = appHelpers.interpretErrorResponse(error);
        this.notify(errorMessage, appConstants.NOTIFY_ERROR);
        this.setState({ contentError: errorMessage });
      });
  };

  handleChange = (event, attribute) => {
    let currState = this.state;
    currState[attribute] = event.target.value;
    let errorMessages = this.state.componentErrorMessages;
    errorMessages[attribute] = false;
    this.setState(currState);
    this.setState({ componentErrorMessages: errorMessages });
  };

  persistDateChange = (ev, attribute) => {
    const selDate = ev.target.value.split("/");
    let dt = new Date(selDate[2] + "-" + selDate[0] + "-" + selDate[1]);
    if (attribute === "startDate") {
      this.setState({ startDate: dt });
    } else if (attribute === "endDate") {
      this.setState({ endDate: dt });
    }
  };

  handleStartDateChange = (target) => {
    let componentErrorMessages = this.state.componentErrorMessages;
    componentErrorMessages["startDate"] = false;
    this.setState({
      startDate: target,
      componentErrorMessages: componentErrorMessages,
    });
  };
  handleEndDateChange = (target) => {
    let componentErrorMessages = this.state.componentErrorMessages;
    componentErrorMessages["endDate"] = false;
    this.setState({
      endDate: target,
      componentErrorMessages: componentErrorMessages,
    });
  };

  handleAirlineChange = (payload) => {
    let errorMessages = this.state.componentErrorMessages;
    errorMessages["AirlineCode"] = false;
    if (payload) {
      this.setState({
        componentErrorMessages: errorMessages,
        AirlineCode: payload.Code,
        AirlineId: payload.Id,
        AirlineName: payload.Name,
      });
    } else {
      this.setState({
        componentErrorMessages: errorMessages,
        AirlineCode: "",
        AirlineId: "",
        AirlineName: "",
      });
    }
  };

  handleSelectChange = (payload, attribute, stateAttribute) => {
    let { activeDestinationAirport, activeSourceAirport } = this.state;
    // let currState = this.state;
    const attributeValue = payload ? payload[attribute] : ""; //Cater for setting up data and clearing data
    let errorMessages = this.state.componentErrorMessages;
    errorMessages[stateAttribute] = false;
    // this.setState(currState);
    if (stateAttribute === "sourceAirportId") {
      activeSourceAirport = payload;
    }
    if (stateAttribute === "destinationAirportId") {
      activeDestinationAirport = payload;
    }

    this.setState({
      componentErrorMessages: errorMessages,
      [stateAttribute]: attributeValue,
      activeDestinationAirport,
      activeSourceAirport,
    });
  };

  handleCategoryChange = (payload) => {
    let currState = this.state;
    currState["selectedCategory"] = payload ? payload["Id"] : ""; //Cater for setting up data and clearing data
    let errorMessages = this.state.componentErrorMessages;
    errorMessages["selectedCategory"] = false;
    this.setState(currState);
    this.setState({ componentErrorMessages: errorMessages });

    this.fetchReports();
  };

  validateInput = () => {
    let _errs_ = [];
    let formValid = true;
    const { sourceAirportId, AirlineCode, notifyEmail, startDate, endDate } =
      this.state;

    if (sourceAirportId === "") {
      _errs_["sourceAirportId"] = "Please select source airport";
      formValid = false;
    }
    if (AirlineCode === "") {
      _errs_["AirlineCode"] = "Please select airline";
      formValid = false;
    }

    if (this.validateEmail(notifyEmail)) {
      _errs_["notifyEmail"] = "Please provide a valid email address";
      formValid = false;
    }

    if (startDate === "") {
      _errs_["startDate"] = "Please provide a valid start date";
      formValid = false;
    }

    if (endDate === "") {
      _errs_["endDate"] = "Please provide a valid end date";
      formValid = false;
    }

    this.setState({ componentErrorMessages: _errs_ });
    return formValid;
  };

  validateEmail = (email_) => {
    let re =
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/gim;
    return email_ === "" || !re.test(email_);
  };

  handleSubmit = (event) => {
    event.preventDefault();
    this.setState({ isRequesting: true });
    this.resetError();
    if (this.validateInput()) {
      this.processSubmit();
    }
  };

  processSubmit = () => {
    let {
      selectedCategory,
      activeSourceAirport,
      activeDestinationAirport,
      sourceAirportId,
      destinationAirportId,
      startDate,
      endDate,
      AirlineCode,
      AirlineId,
      AirlineName,
      notifyEmail,
    } = this.state;
    const startDate_ = moment(startDate).format("YYYY-MM-DD") + "T00:00:00";
    const endDate_ = moment(endDate).format("YYYY-MM-DD") + "T23:59:59";

    const { dispatch } = this.props;
    dispatch(apiActions.startRequest());

    if (selectedCategory === 1) {
      let domesticPayload = {
        AirlineCode: AirlineCode,
        StartDate: startDate_,
        EndDate: endDate_,
        IsLocal: true,
        Email: notifyEmail,
        Username: this.state.activeUser.userName,
      };
      if (sourceAirportId !== -1)
        domesticPayload.SourceAirportCode = activeSourceAirport.Code;
      if (destinationAirportId !== -1)
        domesticPayload.DestinationAirportCode = activeDestinationAirport.Code;

      commonService.generateDomesticIATAReports(domesticPayload).then((res) => {
        dispatch(apiActions.endRequest());
        if (res.status === appConstants.SUCCESS_RESPONSE) {
          this.resetForm();
          this.notify(
            "Report generation request sent successfully",
            appConstants.NOTIFY_SUCCESS
          );
          setTimeout(() => {
            this.fetchReports();
          }, 1500);
        } else if (res.status === appConstants.ERROR_RESPONSE) {
          dispatch(alertActions.error(res.response));
          dispatch(apiActions.endRequest());
        }
      });
    } else {
      let formatStartDate =
        moment(startDate).format("YYYY-MM-DD") + "T00:00:00";
      let formatEndDate = moment(endDate).format("YYYY-MM-DD") + "T23:59:59";

      let internationalPayload = {
        airlineId: AirlineId,
        airlineCode: AirlineCode,
        airlineName: AirlineName,
        start: formatStartDate,
        end: formatEndDate,
        notifyEmail: notifyEmail,
        userName: this.state.activeUser.userName,
        sourceAirportId: sourceAirportId,
      };

      if (sourceAirportId !== -1)
        internationalPayload.SourceAirportCode = sourceAirportId;

      commonService
        .generateInternationalIATAReports(internationalPayload)
        .then((res) => {
          dispatch(apiActions.endRequest());
          if (res.status === appConstants.SUCCESS_RESPONSE) {
            this.resetForm();
            this.notify(
              "Report generation request sent successfully",
              appConstants.NOTIFY_SUCCESS
            );
            setTimeout(() => {
              this.fetchReports();
            }, 2000);
          } else if (res.status === appConstants.ERROR_RESPONSE) {
            dispatch(alertActions.error(res.response));
            dispatch(apiActions.endRequest());
          }
        });
    }
  };

  fetchReports(newFetch) {
    const { dispatch } = this.props;
    if (newFetch === undefined) {
      dispatch(apiActions.startRequest());
    } else {
      dispatch(apiActions.startFullPageRequest());
    }

    commonService
      .getIATAReports({
        username: this.state.activeUser.userName,
        isLocal: this.state.selectedCategory === 1,
      })
      .then((res) => {
        if (res.status === appConstants.SUCCESS_RESPONSE) {
          let response = res.response;
          if (this.state.selectedCategory === 1) {
            this.setState({ iataReports: response });
            this.searchPendingReports(response);
          } else {
            this.setState({ iataReports: response });
            this.searchPendingReports(response);
          }
          dispatch(apiActions.endRequest());
        } else if (res.status === appConstants.ERROR_RESPONSE) {
          dispatch(alertActions.error(res.response));
          dispatch(apiActions.endRequest());
        }
      });
  }

  searchPendingReports(reports) {
    let pendingFound = false;
    for (let r of reports) {
      if (r.Status === "Processing") {
        pendingFound = true;
      }
    }

    if (pendingFound) {
      if (!this.state.pendingReportIntervalId) {
        let id___ = setInterval(() => {
          this.pollPendingReportStatus();
        }, 3000);
        this.setState({ pendingReportIntervalId: id___ });
      }
    } else {
      clearInterval(this.state.pendingReportIntervalId);
      this.setState({ pendingReportIntervalId: false });
    }
  }

 

  filterPendingReports(reports) {
    let pendingFound = false;
    for (let r of reports) {
      if (r.Status === "Processing") {
        pendingFound = true;
      }
    }

    if (!pendingFound) {
      clearInterval(this.state.pendingReportIntervalId);
      this.setState({ pendingReportIntervalId: false });
    }
  }

  pollPendingReportStatus() {
    let { activeUser, selectedCategory } = this.state;
    commonService
      .getIATAReports({
        username: activeUser.userName,
        isLocal: selectedCategory === 1,
      })
      .then((res) => {
        if (res.status === appConstants.SUCCESS_RESPONSE) {
          let response = res.response;
          this.setState({ iataReports: response });
          this.filterPendingReports(response);
        } else if (res.status === appConstants.ERROR_RESPONSE) {
          this.notify(res.response, appConstants.NOTIFY_ERROR);
        }
      });
  }

  resetError() {
    this.props.dispatch(modalActions.clear());
    this.props.dispatch(alertActions.clear());
  }

  resetForm() {
    const now_ = new Date();
    this.setState({
      startDate: now_,
      endDate: now_,
      componentError: false,
      componentErrorMessages: [],
      AirlineCode: "",
      AirlineId: "",
      AirlineName: "",
      notifyEmail: "",
      sourceAirportId: -1,
      destinationAirportId: -1,
      activeDestinationAirport: "",
      activeSourceAirport: "",
    });
  }

  renderFormResponse() {
    if (this.state.error) {
      return <div className="alert alert-danger">{this.state.error}</div>;
    } else if (this.state.componentError) {
      return (
        <div className="alert alert-danger">{this.state.componentError}</div>
      );
    } else if (this.state.success) {
      return <div className="alert alert-success">{this.state.success}</div>;
    }
  }

  render() {
    const { pageRequesting, requesting } = this.props;
    let {
      contentError,
      componentErrorMessages,
      airlines,
      airports,
      categories,
      categoriesLocal,
      selectedCategory,
      iataReports,
    } = this.state;
    const { userRole } = appHelpers.getActiveUser();
    const applicable_categories =
      userRole === appConstants.ROLES.STAFF ? categoriesLocal : categories;
    let iataReportLength = iataReports.length;
    let formResponse = this.renderFormResponse();
    console.log(iataReports, "iataReports");

    return (
      <div className="view">
        <ViewContent>
          <Card className="mb-4">
            {/*Progress bar for Pending API Request*/}
            {(pageRequesting || requesting) && !pageRequesting && (
              <Progress
                animated
                striped
                color="success"
                value={100}
                className="mb-2"
              />
            )}

            {/*Display loader when component content is dependent on Data from API*/}
            {pageRequesting && <PageLoading />}

            {/*Display error when component fail to get Data from API*/}
            {contentError && <PageError error={this.state.contentError} />}

            {/*Display component content when Data is gotten from API*/}
            {!contentError && !pageRequesting && (
              <CardBody className="table-responsive">
                <Container>
                  <Row>
                    <Col sm={"4"}>
                      {formResponse}

                      <Form onSubmit={this.handleSubmit}>
                        <FormGroup
                          className={
                            "mb-3 " +
                            (this.state.componentErrorMessages.selectedCategory
                              ? "has-danger"
                              : "")
                          }
                        >
                          <Label className="font-weight-bold">
                            Select Type
                          </Label>
                          <SelectListComponent
                            data={applicable_categories}
                            valueKey="Id"
                            textField="Name"
                            selectValue={selectedCategory}
                            onValueChange={(payload) =>
                              this.handleCategoryChange(payload)
                            }
                          />
                          {componentErrorMessages.selectedCategory && (
                            <FormText color="danger">
                              {" "}
                              {componentErrorMessages.selectedCategory}
                            </FormText>
                          )}
                        </FormGroup>
                        <FormGroup
                          className={
                            "mb-3 " +
                            (this.state.componentErrorMessages.AirlineCode
                              ? "has-danger"
                              : "")
                          }
                        >
                          <Label>Airline</Label>
                          <SelectListComponent
                            data={airlines}
                            valueKey="Code"
                            textField="Name"
                            selectValue={this.state.AirlineCode}
                            onValueChange={(payload) =>
                              this.handleAirlineChange(payload)
                            }
                          />
                          {componentErrorMessages.AirlineCode && (
                            <FormText color="danger">
                              {" "}
                              {componentErrorMessages.AirlineCode}
                            </FormText>
                          )}
                        </FormGroup>
                        <FormGroup
                          className={
                            "mb-3 " +
                            (this.state.componentErrorMessages.sourceAirportId
                              ? "has-danger"
                              : "")
                          }
                        >
                          <Label>Source Airport</Label>
                          <SelectListComponent
                            data={airports}
                            valueKey="Id"
                            textField="Name"
                            selectValue={this.state.sourceAirportId}
                            onValueChange={(payload) =>
                              this.handleSelectChange(
                                payload,
                                "Id",
                                "sourceAirportId"
                              )
                            }
                          />
                          {componentErrorMessages.sourceAirportId && (
                            <FormText color="danger">
                              {" "}
                              {componentErrorMessages.sourceAirportId}
                            </FormText>
                          )}
                        </FormGroup>
                        {selectedCategory === 1 && (
                          <FormGroup
                            className={
                              "mb-3 " +
                              (this.state.componentErrorMessages
                                .destinationAirportId
                                ? "has-danger"
                                : "")
                            }
                          >
                            <Label>Destination Airport</Label>
                            <SelectListComponent
                              data={airports}
                              valueKey="Id"
                              textField="Name"
                              selectValue={this.state.destinationAirportId}
                              onValueChange={(payload) =>
                                this.handleSelectChange(
                                  payload,
                                  "Id",
                                  "destinationAirportId"
                                )
                              }
                            />
                            {componentErrorMessages.destinationAirportId && (
                              <FormText color="danger">
                                {" "}
                                {componentErrorMessages.destinationAirportId}
                              </FormText>
                            )}
                          </FormGroup>
                        )}
                        <FormGroup
                          className={
                            "mb-3 " +
                            (this.state.componentErrorMessages.notifyEmail
                              ? "has-danger"
                              : "")
                          }
                        >
                          <Label>Recipient's Email</Label>
                          <Input
                            type="text"
                            placeholder=""
                            value={this.state.notifyEmail}
                            onChange={(event) =>
                              this.handleChange(event, "notifyEmail")
                            }
                          />
                          {componentErrorMessages.notifyEmail && (
                            <FormText color="danger">
                              {" "}
                              {componentErrorMessages.notifyEmail}
                            </FormText>
                          )}
                        </FormGroup>
                        <FormGroup
                          className={
                            "mb-3 " +
                            (this.state.componentErrorMessages.startDate
                              ? "has-danger"
                              : "")
                          }
                        >
                          <Label>Start Date</Label>
                          <DatePicker
                            className="date-picker_"
                            showMonthDropdown={true}
                            dropdownMode="select"
                            showYearDropdown={true}
                            selected={moment(this.state.startDate)}
                            onChange={this.handleStartDateChange}
                          />
                          {componentErrorMessages.startDate && (
                            <FormText color="danger">
                              {" "}
                              {componentErrorMessages.startDate}
                            </FormText>
                          )}
                        </FormGroup>
                        <FormGroup
                          className={
                            "mb-3 " +
                            (this.state.componentErrorMessages.endDate
                              ? "has-danger"
                              : "")
                          }
                        >
                          <Label>End Date</Label>
                          <DatePicker
                            className="date-picker_"
                            showMonthDropdown={true}
                            dropdownMode="select"
                            showYearDropdown={true}
                            selected={moment(this.state.endDate)}
                            onChange={this.handleEndDateChange}
                          />
                          {componentErrorMessages.endDate && (
                            <FormText color="danger">
                              {" "}
                              {componentErrorMessages.endDate}
                            </FormText>
                          )}
                        </FormGroup>
                        <div className="mb-5">
                          <Button
                            className="btn-avi-primary"
                            disabled={requesting}
                          >
                            {" "}
                            Generate{" "}
                          </Button>{" "}
                        </div>
                      </Form>
                    </Col>
                    <Col sm={"8"}>
                      {!pageRequesting && iataReportLength === 0 && (
                        <PageEmptyContent message="No report yet!" />
                      )}

                      {!pageRequesting && iataReportLength > 0 && (
                        <div>
                          {iataReportLength > 0 && (
                            <div style={{ float: "left" }}>
                              <h6 className="mb-0 text-uppercase">
                                IATA Records
                                <FormText color="muted">
                                  <ReportIcon size="22" color="#43a8df" />
                                  &nbsp;
                                  {appHelpers.numberWithCommasOnly(
                                    iataReportLength
                                  )}{" "}
                                  records matched
                                </FormText>
                              </h6>
                            </div>
                          )}

                          {!requesting && (
                            <h6 style={{ float: "right" }}>
                              <span
                                className="pointer"
                                onClick={() => this.fetchReports()}
                              >
                                <ToolTipItem
                                  key={"refresh__"}
                                  title={
                                    <IconRefresh size="20" color="#43a8df" />
                                  }
                                  content="Refresh"
                                  id={"refresh__"}
                                />
                              </span>
                            </h6>
                          )}
                          {requesting && (
                            <h6 style={{ float: "right" }}>
                              <IconRefresh size="25" color="#43a8df" />
                            </h6>
                          )}
                          <div className="clearfix">&nbsp;</div>
                          <IATATimeline
                            reports={iataReports}
                            fetchCallBack={this.fetchReports}
                          />
                        </div>
                      )}
                    </Col>
                  </Row>
                </Container>
              </CardBody>
            )}
            <NotificationSystem ref="notificationSystem" />
          </Card>
        </ViewContent>
      </div>
    );
  }
}
function mapStateToProps(state, ownProps) {
  const { loggingIn } = state.authentication;
  const { pageRequesting, requesting } = state.api;
  const { modal, alert, airlinesCarriers, desAirports } = state;
  return {
    loggingIn,
    requesting,
    pageRequesting,
    modal,
    alert,
    desAirports,
    airlinesCarriers,
  };
}
export default connect(mapStateToProps)(IataViewContent);



// WEBPACK FOOTER //
// ./src/views/iata/view-content.js